module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " white-background pa-5 rounded ma-1"
  }, _vm._l((_vm.$page.activities), function(activity) {
    return _c('div', {
      staticClass: "flow-activity clickable hoverable ma-1"
    }, [_c('SpeechBubble', {
      attrs: {
        "activity": activity
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bbecee4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/FlowActivity.vue
// module id = 2490
// module chunks = 1